import { Observable } from 'rxjs';

import { Directive, Input, TemplateRef } from '@angular/core';

import { MediaBreakpointDeviceLiteral } from '../models';

import { IfConditionStructuralBaseDirective } from './if-condition-structural-base.directive';

@Directive({
	selector: '[bpIfGreaterThan]',
})
export class IfGreaterThanDirective extends IfConditionStructuralBaseDirective {
	@Input()
	set bpIfGreaterThan(mediaBreakpointDeviceLiteral: MediaBreakpointDeviceLiteral) {
		this._setMediaBreakpointDeviceLiteral(mediaBreakpointDeviceLiteral);
	}

	@Input()
	set bpIfGreaterThanThen(templateRef: TemplateRef<any>) {
		this._setThenTemplate(templateRef);
	}

	@Input()
	set bpIfGreaterThanElse(templateRef: TemplateRef<any> | null) {
		this._setElseTemplate(templateRef);
	}

	override onMediaBreakpointConditionChange$(mediaBreakpointDeviceLiteral: MediaBreakpointDeviceLiteral): Observable<boolean> {
		return this._mediaService.greaterThan$(mediaBreakpointDeviceLiteral);
	}
}
